import { render } from "./MGSheetSlide.vue?vue&type=template&id=0ac0ed36&scoped=true"
import script from "./MGSheetSlide.vue?vue&type=script&lang=js"
export * from "./MGSheetSlide.vue?vue&type=script&lang=js"

import "./MGSheetSlide.vue?vue&type=style&index=0&id=0ac0ed36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac0ed36"]])

export default __exports__